export default [
    {
        name: 'subnet',
        sortField: 'subnet',
        type: 'ip',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'ips_count',
        sortField: 'ips_count',
        type: 'number',
        callback: 'number',
        // dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:backdomains_subnet_count',
        sortField: 'domains_count',
        type: 'number',
        callback: 'number',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:backlinks_subnet_count',
        sortField: 'backlinks_count',
        type: 'number',
        callback: 'humanNumber',
        defaultSearch: false,
        useInFilter: true,
    },
]
